import { AppState } from '../../../../state/AppState';
import { currentUserIsAdmin, hasRunNowPermission } from '../../../../utils/MixedContentHelpers';
import { dataAccelerationTaskRunNow } from '../../../../actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { EntityActionNames, IEntityAction } from '../IEntityAction';
import { IAccelerationTaskInfo } from '../../../../../ts/models/IAccelerationTaskInfo';
import { IDatasourceActions } from '../../../../../ts/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../../../../ts/ServerApi/types/IWorkbookActions';
import { Messages } from '../../../../../codegen/Localize';
import { selectSpaceInfoItem } from '../../../../selectors/SpaceInfoSelectors';

export const DataAccelerationRunNowEntityAction: IEntityAction<IAccelerationTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.accelerateNow_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: dataAccelerationTaskRunNow
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IAccelerationTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return currentUserIsAdmin(state) && hasRunNowPermission(state);
}
